<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="custom_card work_hours_card">
                    <v-card-title v-if="title">
                        <v-container fluid>
                            <span class="headline" v-html="title"></span>
                        </v-container>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <slot name="form"></slot>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        components: {},
        props: {
            title: {
                type: String,
                default: null
            }
        },
        methods: {},
    };
</script>